import { emptySplitApi } from "../emptySplit-api";

export const notificationApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    notificationList: builder.query<any, any>({
      query: (data = {}) => ({
        url: `/notifications/list`,
        method: "post",
        body: data,
      }),
      providesTags: ["Notification"],
    }),
    notificationUnreadCount: builder.query<any, void>({
      query: () => ({
        url: `/notifications/unread-count`,
        method: "post",
        body: {},
      }),
      providesTags: ["Notification"],
    }),
    notificationMarkRead: builder.mutation<
      any,
      string | { orderId?: string } | undefined
    >({
      query: (arg) => {
        if (typeof arg === "string") {
          return {
            url: `/notifications/mark-read/${arg}`,
            method: "post",
          };
        }
        return {
          url: `/notifications/mark-read`,
          method: "post",
          body: arg || {},
        };
      },
      invalidatesTags: ["Notification"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useNotificationListQuery,
  useNotificationUnreadCountQuery,
  useNotificationMarkReadMutation,
} = notificationApi;
